//Books
import React, { useState, useEffect } from 'react';
import { IMG_URL } from '../../../utility/config';
import { getMethod } from '../../../services/apiService';
import Bookscard from './Bookscard';
import LoadingSpinner from '../../../utility/LoadingSpinner';

function Books() {
  const [bookData, setBookData] = useState([]);
  const IMG_BASE_URL = IMG_URL
  useEffect(() => {
    fetchData();
  }, []);

  //Display books
  const fetchData = async () => {
    try {
      const response = await getMethod('poems');
      console.log("=book==========", response)
      if (response && response.status && response.data && Array.isArray(response.data.data)) {
        setBookData(response.data.data);
      } else {
        console.error("Invalid response format:", response);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  if (bookData.length === 0) return <LoadingSpinner />;

  return (
    <div className="booksdiv" >
      <div className="poem-list">
        {Array.isArray(bookData) &&
    bookData
      .filter(item => item.book_img_url && item.title && item.id && item.poem_content) // Filter valid books
      .map(item => (
        <div key={item.id}>
          <Bookscard
            className="poem-list__item"
            book_img_url={`${IMG_BASE_URL}/${item.book_img_url}`}
            title={item.title}
            id={item.id}
            poem_content={item.poem_content}
            price={item.price}
          />
        </div>
      ))}
      </div>
    </div>
  );

}

export default Books;